// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{font-size:16px;word-spacing:1px;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;box-sizing:border-box;height:100%}body,html{font-family:\"Raleway\",sans-serif}body{background-color:#fff}.body-container{display:flex;min-height:100vh;flex-direction:column}.content{flex:1}.footer{margin-top:auto}*,:after,:before{box-sizing:border-box;margin:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
